import { z } from "zod";

export const BaseStatisticsInputSchema = z.object({
    dateFrom: z.date(),
    dateTo: z.date(),
    requestTypes: z.array(z.number()),
    sourceTypes: z.array(z.number()),
    processingTypes: z.array(z.number()),
});

export type BaseStatisticsInput = z.infer<typeof BaseStatisticsInputSchema>;